<template>
  <v-data-table
    :headers="headers"
    :items="lineItems"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="LineItem-button-new"
          @click="$router.push({
            name: 'line-item-EditLineItem'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'line-item-EditLineItem',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListLineItem',
  module: 'LineItem',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('lineItems', ['lineItems']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('description'),
          value: 'description',
        },
        {
          text: this.$$t('quantity'),
          value: 'quantity',
        },
        {
          text: this.$$t('unitAmount'),
          value: 'unitAmount',
        },
        {
          text: this.$$t('accountCode'),
          value: 'accountCode',
        },
        {
          text: this.$$t('lineItemID'),
          value: 'lineItemID',
        },
        {
          text: this.$$t('taxType'),
          value: 'taxType',
        },
        {
          text: this.$$t('taxAmount'),
          value: 'taxAmount',
        },
        {
          text: this.$$t('lineAmount'),
          value: 'lineAmount',
        },
        {
          text: this.$$t('discountRate'),
          value: 'discountRate',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_lineItems();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('lineItems', ['LOAD_lineItems', 'DELETE_lineItem']),
    /** Delete LineItem from the collection
     */
    async remove(LineItem) {
      this.isLoading = true;
      await this.DELETE_LineItem(LineItem);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# LineItem example

'''js
<LineItem />
'''
</docs>
